/**
 * `_app/admin` layout — the staff super-admin surface.
 *
 * The layout only owns the `<AdminGate>`; each child route renders its own
 * `<Island>` (list vs reconciliation detail are independent surfaces, not a
 * shared two-pane like Settings). Disabled entirely in the demo build.
 */
import { AdminGate } from '@/components/shell/AdminGate';
import { DEMO } from '@/lib/demo';
import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/admin')({
  beforeLoad: () => {
    if (DEMO) throw redirect({ to: '/performance' });
  },
  component: AdminLayout,
});

function AdminLayout() {
  return (
    <AdminGate>
      <Outlet />
    </AdminGate>
  );
}
